/**
 * @file header-actions.js
 */

export default {
    // 是否显示操作框
    setIsShow(state, val) {
        state.isShow = val;
    },
    // 设置用户信息
    setUserInfo(state, data) {
        if (data.isLogin) {
            state.isLogin = true;
            state.isOfficial = data.userInfo.isOfficial;
            state.isBanned = data.userInfo.isBanned;
            state.avatar = data.userInfo.avatar;
            state.userName = data.userInfo.nickname;
            state.userNo = data.userInfo.userNo;
            state.permission = data.userInfo.permission;
            state.isOutside = false;
            state.relationVirtualUserList = data.userInfo.userType === 2
                ? [data.passUserInfo, ...data.relationVirtualUserList]
                : data.relationVirtualUserList;
        }
        else {
            location.assign(state.openSourceProgram);
            state.isLogin = false;
        }
    }
};
